import { lazy, useRef, useState } from "react";

import Suspense from "components/shared/Suspense";
import { Drawer } from "features/Drawer";
import { secondsFormat } from "lib/bookUtils";
import { EditionSerializersEditionByline } from "types/serializers";

// TODO: #1876 after switching to using EditableProgressForm, remove this folder

const EditAudioProgressDrawer = lazy(() => import("./EditAudioProgressDrawer"));

export default function EditableAudioProgress({
  audioSeconds,
  currentSeconds,
  edition,
  message,
  onChange,
}: {
  audioSeconds: number | null;
  edition: EditionSerializersEditionByline;
  message?: string;
  currentSeconds: number | null;
  onChange: (progress: number) => Promise<any>;
}) {
  const buttonRef = useRef<HTMLButtonElement>();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div>
      <button
        type="button"
        className="font-semibold underline decoration-dotted"
        data-tooltip-id="tooltip"
        data-tooltip-content="Click to update"
        ref={buttonRef}
        onClick={() => setIsEditing(true)}
      >
        {currentSeconds ? secondsFormat(currentSeconds) : "0h 0m"}
      </button>

      {isEditing && buttonRef?.current && (
        <Suspense
          fallback={
            <Drawer.Loading
              settings={{
                ref: buttonRef.current,
                onClose: () => {},
                isOpen: true,
                offset: [-20, 10],
              }}
            />
          }
        >
          <EditAudioProgressDrawer
            attachElement={buttonRef.current}
            audioSeconds={audioSeconds}
            currentSeconds={currentSeconds}
            edition={edition}
            message={message}
            onChange={onChange}
            onDone={() => setIsEditing(false)}
          />
        </Suspense>
      )}
    </div>
  );
}
